var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"flex-grow-1"}),_c('b-button',{attrs:{"variant":"outline-danger mx-3"},on:{"click":function($event){return _vm.$router.push('/manage-alf')}}},[_vm._v("Cancel ")]),(_vm.isSubmit)?_c('b-button',{attrs:{"variant":"success","type":"submit"}},[_vm._v("Submit ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }